export const getFaqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  '@id': 'https://inspektlabs.com/#faq',

  about: {
    '@id': 'https://inspektlabs.com/#software',
  },

  isPartOf: {
    '@id': 'https://inspektlabs.com/#software',
  },

  publisher: {
    '@id': 'https://inspektlabs.com/#organization',
  },

  mainEntity: [
    {
      '@type': 'Question',
      name: 'What is AI-powered vehicle inspection?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'AI-powered vehicle inspection is a technology that uses artificial intelligence to analyze vehicle images or videos and automatically detect damages such as dents, scratches, and cracks, generating instant inspection reports.',
      },
    },
    {
      '@type': 'Question',
      name: 'Who can use your product for vehicle inspections?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Inspektlabs is used by insurance companies, car rental businesses, fleet operators, dealerships, and automotive marketplaces to automate and standardize vehicle inspections.',
      },
    },
    {
      '@type': 'Question',
      name: 'How does AI vehicle inspection work?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'AI vehicle inspection works by capturing vehicle images or videos, which are analyzed using machine learning models to identify damages, assess condition, and generate automated reports in real time.',
      },
    },
    {
      '@type': 'Question',
      name: 'Does Inspektlabs support both photos and videos for inspections?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, Inspektlabs supports both photos and videos, allowing AI to analyze visual data from multiple formats for accurate and flexible vehicle inspections.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can I use your product to conduct FNOL (First Notice of Loss)?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, Inspektlabs can be used for FNOL by allowing customers to submit vehicle images or videos at the time of claim initiation, enabling faster damage assessment and claim processing.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can I use your product to conduct pre-inspections?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, Inspektlabs supports pre-inspections by enabling users to capture vehicle condition before usage, helping prevent disputes and establish a clear baseline.',
      },
    },
    {
      '@type': 'Question',
      name: 'What type of damages and parts does Inspektlabs cover?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Inspektlabs detects damages such as dents, scratches, cracks, and broken parts across vehicle components like panels, bumpers, lights, and windshields.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can Inspektlabs provide repair cost estimates?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, Inspektlabs can estimate repair costs by analyzing detected damages and mapping them to repair methodologies, helping insurers and businesses make faster and more accurate decisions.',
      },
    },
    {
      '@type': 'Question',
      name: 'How does Inspektlabs handle VIN, license plates, and odometer readings?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Inspektlabs uses AI and OCR technology to automatically extract VIN numbers, license plates, and odometer readings from images and videos, ensuring accurate and automated data capture.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can Inspektlabs integrate with my existing systems?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, Inspektlabs integrates with existing systems such as claims management, fleet platforms, and dealer systems using APIs, enabling seamless data exchange and automated workflows.',
      },
    },
  ],
};